module.exports = __webpack_public_path__ + "img/desire_005.16c2be2.webp";